// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-ded1ca22]{color:#f1f1f1;background:#444}", ""]);
// Exports
module.exports = exports;
